module.exports = __webpack_public_path__ + "img/d56baed.png";